import { createContext } from 'react';

type FocusRestorationContextType = {
	shouldRestoreFocusRef: { current: boolean };
};

export const FocusRestorationContext = createContext<FocusRestorationContextType>({
	shouldRestoreFocusRef: { current: false },
});
